import { useSelector } from 'react-redux';

import { StateType } from '@app/types/reducer-state';

export const useOrganizationId = () => useSelector((state: StateType) => state?.organizations?._id || '');

export const useOrganization = () => useSelector((state: StateType) => state?.organizations || {});

export const useOrganizationDisplayName = () => useSelector((state: StateType) => state?.organizations?.displayName || state?.organizations?.name || '');
